import {
  BACKGROUND_FAR_STAR_MAX_ALPHA,
  BACKGROUND_FAR_STAR_MIN_ALPHA,
  BACKGROUND_NEAR_STAR_MAX_ALPHA,
  BACKGROUND_NEAR_STAR_MIN_ALPHA,
} from '../../../ClickerGame.constants';

import {ParticleEmitterConfig, SpawnShapeBehavior} from '@specials/particle-emitter';

export const backgroundNearStarConfig = (spawnShape: SpawnShapeBehavior): ParticleEmitterConfig => ({
  emitterConfig: {
    autoStart: false,
  },
  particleConfig: {
    alpha: {
      value: 1,
      multiplier: {
        min: BACKGROUND_NEAR_STAR_MIN_ALPHA,
        max: BACKGROUND_NEAR_STAR_MAX_ALPHA,
      },
    },
    direction: {
      angle: 90,
    },
    scale: {
      value: 1,
      multiplier: {
        min: 0.05,
        max: 0.1,
      },
    },
    spawnShape,
  },
});

export const backgroundFarStarConfig = (spawnShape: SpawnShapeBehavior): ParticleEmitterConfig => ({
  emitterConfig: {
    autoStart: false,
  },
  particleConfig: {
    alpha: {
      value: 1,
      multiplier: {
        min: BACKGROUND_FAR_STAR_MIN_ALPHA,
        max: BACKGROUND_FAR_STAR_MAX_ALPHA,
      },
    },
    direction: {
      angle: 90,
    },
    scale: {
      value: 1,
      multiplier: {
        min: 0.025,
        max: 0.05,
      },
    },
    spawnShape,
  },
});
